var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowTeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "22px",
    viewBox: "0 0 14 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow_teal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MPLP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-574.000000, -222.000000)",
    fill: "#fff",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow_teal",
    transform: "translate(574.000000, 222.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.1439349,22 C0.823506,22 0.5053658,21.8678015 0.276488,21.6101263 C-0.135492,21.1418298 -0.0805613,20.4337833 0.3977933,20.0304657 L11.104696,11.0028735 L0.3977933,1.96855927 C-0.0805613,1.56300101 -0.135492,0.857195216 0.276488,0.388898671 C0.6930456,-0.0816385274 1.4117219,-0.130932901 1.8900764,0.272384698 L13.6040414,10.1536659 C13.855807,10.3665279 14,10.6757381 14,11.0028735 C14,11.3277682 13.855807,11.6369784 13.6017527,11.8520811 L1.8900764,21.7288809 C1.6749313,21.9081332 1.4094331,22 1.1439349,22",
    id: "Fill-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTeal);
export default __webpack_public_path__ + "static/media/arrow_teal.29ed0d06a76099ce20f9506c2e9db07a.svg";
export { ForwardRef as ReactComponent };